import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const DYNAMICS = [
  {
    key: "traditional",
    label: "Traditional",
    desc: "One primary provider, defined roles, a warm classic home.",
  },
  {
    key: "equal_partnership",
    label: "50/50 Partnership",
    desc: "Finances, household, and decisions split equally.",
  },
  {
    key: "flexible",
    label: "Flexible / Hybrid",
    desc: "Roles adapt as the seasons of life change.",
  },
  {
    key: "career_focused",
    label: "Dual Career",
    desc: "Both partners pursue ambitious careers, side by side.",
  },
  {
    key: "homemaker_supported",
    label: "Homemaker Supported",
    desc: "One partner devoted to the home, fully supported.",
  },
];

export const TIMELINES = [
  { key: "within_1_year", label: "Within 1 year" },
  { key: "1_2_years", label: "1–2 years" },
  { key: "2_3_years", label: "2–3 years" },
  { key: "open_timeline", label: "Open, but intentional" },
];

export const VALUES = [
  "faith",
  "family",
  "children",
  "career",
  "finances",
  "honesty",
  "loyalty",
  "adventure",
  "growth",
  "stability",
  "travel",
  "ambition",
];

export const dynamicLabel = (key) =>
  DYNAMICS.find((d) => d.key === key)?.label || key;

export const timelineLabel = (key) =>
  TIMELINES.find((t) => t.key === key)?.label || key;
